// ABOUTME: Enums for what a dashboard cell holds — the report format (chart vs pivot) and, for pivots,
// ABOUTME: the bounded view variant plus its default row count. Shared by the picker, renderer, and pre-agg.

// A cell references a saved report by id; `kind` is the report's format (derived from its reportType).
// COMPONENT cells are different: they hold no report, just a pre-built warehouse widget (chart.componentKey).
export const dashboardCellKinds = {
    CHART: "chart",
    PIVOT: "pivot",
    COMPONENT: "component",
};

// Pivots are restricted in a cell to a bounded view (data-volume guard). FULL = the whole pivot, rendered
// live; the others are pre-aggregated to N rows.
export const dashboardPivotVariants = {
    TOP: "top",
    BOTTOM: "bottom",
    MOVERS: "movers",
    FULL: "full",
};

export const DEFAULT_PIVOT_N = 10;
